import React, { useState } from 'react';

import EditBorderButton from 'Components/Buttons/EditBorderButton';
import EditTestOrderModal from 'Components/SingleProject/Modals/EditTestOrderModal';
import ErrorMessage from 'Components/UI/ErrorMessage';

export default function ReorderTestsBtn({ disabled, projectTests }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [mainError, setMainError] = useState('');

  return (
    <React.Fragment>
      <EditBorderButton
        disableStyles={true}
        text="Edit test order"
        clickAction={() => setModalOpen(true)}
        extraBtnProps={{ disableFocusRipple: true, disabled }}
      />
      <EditTestOrderModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        projectTests={projectTests}
      />
      {!!mainError && (
        <ErrorMessage
          message={mainError}
          handleCloseErrorAlert={() => setMainError(null)}
        />
      )}
    </React.Fragment>
  );
}
